export const environment = {
  production: false,
  envName: "homolog",
  defaultauth: "fackbackend",

  hereApiKey: "jQTTSU_49OKaFUI4hpW10P5Hk8p3LqFme0WSO8_WVNs",

  apiBaseAddress: "https://tracker-homolog-api.workfinity.com.br/api/",

  viewTenantCode: true,

  version: "2.0.0",
};

export const custom = {
  logo_login: null,
  codeTenant: null,
};
